import { AuthenticationResult } from "@azure/msal-browser";
import { getLcmsToken, setOptionHeaders } from "../auth/getAccessToken";

export class ClientBase {
  protected async transformOptions(options: RequestInit): Promise<RequestInit> {
    let token: AuthenticationResult = await getLcmsToken();
    setOptionHeaders(options, token.accessToken);

    return Promise.resolve(options);
  }
}
